import axios, { AxiosError, AxiosResponse } from 'axios';
import { getLocalStorage } from 'utils/storage';

import { ApiErrorResponse, onError } from './errors';

export class Axios {
  protected constructor(protected host: string = '') {}

  private getHeaders() {
    const user = getLocalStorage('user');
    return {
      Authorization: `Bearer ${user?.token}`,
      'Content-Type': 'application/json',
    };
  }

  async get<T>(path: string) {
    try {
      const res: AxiosResponse<T> = await axios({
        method: 'get',
        url: `${this.host}${path}`,
        headers: this.getHeaders(),
      });
      return res.data;
    } catch (err) {
      throw onError(err as AxiosError<ApiErrorResponse>);
    }
  }

  async post<T>(path: string, data = {}) {
    try {
      const res: AxiosResponse<T> = await axios({
        method: 'post',
        url: `${this.host}${path}`,
        headers: this.getHeaders(),
        data,
      });
      return res.data;
    } catch (err) {
      throw onError(err as AxiosError<ApiErrorResponse>);
    }
  }

  async put<T>(path: string, data = {}) {
    try {
      const res: AxiosResponse<T> = await axios({
        method: 'put',
        url: `${this.host}${path}`,
        headers: this.getHeaders(),
        data,
      });
      return res.data;
    } catch (err) {
      throw onError(err as AxiosError<ApiErrorResponse>);
    }
  }

  async delete<T>(path: string) {
    try {
      const res: AxiosResponse<T> = await axios({
        method: 'delete',
        url: `${this.host}${path}`,
        headers: this.getHeaders(),
      });
      return res.data;
    } catch (err) {
      throw onError(err as AxiosError<ApiErrorResponse>);
    }
  }

  async patch<T>(path: string, data = {}) {
    try {
      const res: AxiosResponse<T> = await axios({
        method: 'patch',
        url: `${this.host}${path}`,
        headers: this.getHeaders(),
        data,
      });
      return res.data;
    } catch (err) {
      throw onError(err as AxiosError<ApiErrorResponse>);
    }
  }
}
